import {CreateQuestion, IdentifiedSheetSection} from "platformed-client/types";
import {platformedClient} from "..";

type Sheet = {[row: number]: {[col: number]: string}};

export async function identifySheetSections(sheet: Sheet): Promise<IdentifiedSheetSection[]> {
  return await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/ai/identify_sheet_sections`,
    {body: sheet},
  );
}

type Cell = {content: string | null; options?: string[]};

type SheetSection = {section_title?: string; cells: Cell[][]};

export async function extractSectionQuestions(section: SheetSection): Promise<CreateQuestion[]> {
  return await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/ai/extract_section_questions`,
    {body: section},
  );
}
